/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../shared/GlobalStyles';
import CreateNewExerciseForm from '../components/presentational/CreateNewExerciseForm';
import Text from '../../../shared/components/Text/Text';

const ModalContainer = styled('div')`
    .remove-div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      background: transparent;
      z-index: 1001;
      .remove-div-icon {
        cursor: pointer;
        transition: ${TransitionGlobal};
        :hover {
          opacity: 0.7;
        }
      }
    }
  height: 100%;
  position: relative;
`;

const ModalTextTop = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${(props) => !props.disabledEditModal && '12px'};
   @media (max-width: 370px) {
    font-size: 22px;
  }
`;

const ViewOnlyWarning = styled('div')`
  display: flex;
  gap: 12px;
  background: ${({ theme }) => theme.colors.warningSurface};
  border: 1px solid ${({ theme }) => theme.colors.warningBorder};
  border-radius: 8px;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 11px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.4;
  /* The banner keeps its light yellow background in dark mode, so the text
     must stay dark rather than follow the theme. */
  color: ${({ theme }) => theme.colors.warningText};
  p {
    font-size: 11pt;
    color: ${({ theme }) => theme.colors.warningText};
  }
`;

const ModalTextTopContainer = styled('div')`
display: flex;
flex-direction: column;
`;

const CreateNewComponentModal = ({
  closeModal,
  onSuccessOverride,
  onSimilarCheckOpenChange,
}) => {
  const { colors } = useTheme();
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const isReusableItem = modalData?.itemInfoForEditModal?.reusableItem === 1;
  return (
    <ModalContainer>
      <div className='remove-div'>
        <div style={{
          display: 'flex',
          alignItems: 'center',
        }}
        >
          <ModalTextTopContainer>
            <ModalTextTop disabledEditModal={modalData?.disabledEditModal}>
              {modalData?.disabledEditModal ? (
                'About Item'
              ) : (
                'Create New Exercise'
              )}
            </ModalTextTop>
            {modalData?.disabledEditModal && isReusableItem && (
              <ViewOnlyWarning>
                <IcomoonReact
                  iconSet={iconSet}
                  size={18}
                  icon='warning'
                  color='#F59E0B'
                />
                <Text>This item is saved to the exercise database, to make changes view the exercise in your exercise database.</Text>
              </ViewOnlyWarning>
            )}
          </ModalTextTopContainer>
        </div>
        <div
          className='remove-div-icon'
          onClick={() => closeModal()}
        >
          <IcomoonReact
            iconSet={iconSet}
            size={15}
            icon='remove'
            color={colors.textSecondary}
          />
        </div>
      </div>
      <CreateNewExerciseForm
        closeModal={closeModal}
        onSuccessOverride={onSuccessOverride}
        onSimilarCheckOpenChange={onSimilarCheckOpenChange}
        unifiedVideoFlow
      />
    </ModalContainer>
  );
};

CreateNewComponentModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  // Optional override that bypasses the form's default success path so
  // callers (e.g. the AI import wizard) can take the created exercise
  // and run their own follow-up logic instead.
  onSuccessOverride: PropTypes.func,
  // Forwarded to the form so the host can hide this modal while the
  // similar-exercises dialog is open.
  onSimilarCheckOpenChange: PropTypes.func,
};

CreateNewComponentModal.defaultProps = {
  onSuccessOverride: null,
  onSimilarCheckOpenChange: null,
};

export default CreateNewComponentModal;
